import smares from './smares.jpg';
import smaresPos from './smares_pos.jpg';
import smaresSmartMenu from './smares-smart-menu.jpg';
import programmingProblems from './programming-problems.jpg';
import bursaMetro from './bursa.jpg';

export {
	smares,
	smaresPos,
    smaresSmartMenu,
	programmingProblems,
	bursaMetro
}



// WEBPACK FOOTER //
// ./src/assets/images/posts/index.js